import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './assets/styles.scss';

import ImgLogoBestBitcoinCasino from './assets/images/logos/best-bitcoin-casino.png?sizes[]=120';
import ImgLogoSvPool from './assets/images/logos/sv-pool.png?sizes[]=120';
import ImgLogoCoinGeek from './assets/images/logos/coingeek.png?sizes[]=120';
import ImgLogoCGN from './assets/images/logos/cgn.png?sizes[]=120';
import ImgLogoCaCom from './assets/images/logos/ca.com.png?sizes[]=120';
import ImgLogoIGamingBSV from './assets/images/logos/igamingbsv.png?sizes[]=120';
import ImgLogoBeGambleAware from './assets/images/logos/begambleaware.png?sizes[]=120';
import ImgLogoGA from './assets/images/logos/ga.png';
import ImgLogoCasinoGuru from './assets/images/logos/casinoguru.png';
import ImgLogoGamblingNews from './assets/images/logos/gambling-news.png';
import ImgLogoProvablyFair from './assets/images/logos/provably-fair.svg';
import ImgLogoResponsibleGaming from './assets/images/logos/responsible-gaming.svg';
import ImgLogoSafeSecure from './assets/images/logos/safe-secure.svg';
import ImgLogoPeergame from './assets/images/logos/peergame-light.svg';

import ImgIconDiscord from './assets/images/icons/discord.svg';
import ImgIconTelegram from './assets/images/icons/telegram.svg';
import ImgIconTwitter from './assets/images/icons/twitter.svg';
import ImgIconBitcointalk from './assets/images/icons/bitcointalk.svg';
import ImgIconAdult from './assets/images/icons/eighteenplus.png';

const cx = classNames.bind(styles);

// function initLicenseBadge() {
//   const script = window[`ceg_${config.curacaoLicenseId.replace(/-/g, '_')}`];

//   if (script) {
//     script.init();
//   } else {
//     setTimeout(() => initLicenseBadge(), 500);
//   }
// }

class Footer extends Component {
  // static propTypes = {
  //   color: PropTypes.oneOf(['black', 'white']),
  //   landing: PropTypes.bool,
  // };

  // static defaultProps = {
  //   color: 'black',
  //   landing: false,
  // };
  // componentDidMount() {
  //   initLicenseBadge();
  // }

  render() {
    // const { color, landing } = this.props;
    // const pg = config.app.title === 'Peergame';
    // const copyRightContent = <p>© 2020</p>;

    // let logo = imgNmgLogo;
    // if (pg) {
    //   logo = color === 'black' ? imgPgLogoBlack : imgPgLogoWhite;
    // }

    return (
      <>
        {/* <Helmet>
          <script type="text/javascript" src={`https://${config.curacaoLicenseId}.curacao-egaming.com/ceg-seal.js`} />
        </Helmet> */}
        <footer>
          <div className={cx('footer-top-section', 'container')}>
            <div className={cx('footer-top-logo-box')}>
              <a
                href="https://www.bestbitcoincasino.com/review/peergame"
                target="_blank"
                rel="noopener noreferrer"
                title="Best Bitcoin Casinos"
              >
                <img src={ImgLogoBestBitcoinCasino} alt="" />
              </a>
            </div>
            <div className={cx('footer-top-logo-box')}>
              <a href="https://svpool.com/tag/peergame" target="_blank" rel="noopener noreferrer" title="SV Pool">
                <img src={ImgLogoSvPool} alt="" />
              </a>
            </div>
            <div className={cx('footer-top-logo-box')}>
              <a
                href="https://coingeek.com/news/tag/peergame"
                target="_blank"
                rel="noopener noreferrer"
                title="CoinGeek"
              >
                <img src={ImgLogoCoinGeek} alt="" />
              </a>
            </div>
            <div className={cx('footer-top-logo-box')}>
              <a
                href="https://www.igamingbsv.com/gambling/peergame"
                target="_blank"
                rel="noopener noreferrer"
                title="IGaming BSV"
              >
                <img src={ImgLogoIGamingBSV} alt="" />
              </a>
            </div>
            <div className={cx('footer-top-logo-box')}>
              <a href="https://casino.guru/" target="_blank" rel="noopener noreferrer" title="Casino Guru">
                <img src={ImgLogoCasinoGuru} alt="" />
              </a>
            </div>
            <div className={cx('footer-top-logo-box')}>
              <a href="https://www.gamblingnews.com/" target="_blank" rel="noopener noreferrer" title="Casino Guru">
                <img src={ImgLogoGamblingNews} alt="" />
              </a>
            </div>
            <div className={cx('footer-top-logo-box')}>
              <a
                href="https://www.cryptogamblingnews.com/"
                target="_blank"
                rel="noopener noreferrer"
                title="Crypto Gambling News"
              >
                <img src={ImgLogoCGN} alt="" />
              </a>
            </div>
          </div>
          <hr />
          <div className={cx('footer-bottom-section', 'container')}>
            <div className={cx('footer-left-block')}>
              <div className={cx('footer-left-block-top')}>
                <div>
                  <img src={ImgLogoPeergame} alt="" className={cx('logo')} />
                  {/* <div
                    id={`ceg-${config.curacaoLicenseId}`}
                    data-ceg-seal-id={config.curacaoLicenseId}
                    data-ceg-image-size="60"
                    data-ceg-image-type="basic-large"
                  /> */}
                </div>
                <div>
                  <h6>© Peergame, 2022</h6>
                  <p className="xsmall">
                    Peergame provides 100% fairness and transparency.
                    To be a user of our site, you must be over 18 years old.
                    If igaming and online betting are not allowed in your region for legal,
                    please avoid using our services.
                  </p>
                  <div className={cx('footer-left-block-bottom')}>
                    <img src={ImgLogoProvablyFair} alt="" />
                    <img src={ImgLogoResponsibleGaming} alt="" />
                    <img src={ImgLogoSafeSecure} alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div className={cx('footer-menu-block')}>
              <ul>
                <li>
                  <Link to="/about-us">About Peergame</Link>
                </li>
                <li>
                  <Link to="/games">Games</Link>
                </li>
                <li>
                  <Link to="/partners">Peergame Partners</Link>
                </li>
                <li>
                  <Link to="/provably-fair">Provably Fair</Link>
                </li>
                <li>
                  <Link to="/bitcoinsv">Bitcoin SV</Link>
                </li>
                <li>
                  <a href="https://blog.peergame.com/">Blog</a>
                </li>
                <li>
                  <Link to="/payments">Payments</Link>
                </li>
                <li>
                  <a href="https://peergame.crunch.help/" target="_blank" rel="noopener noreferrer">
                    Help Center
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <Link to="/responsible-gaming">Responsible Gaming</Link>
                </li>
                <li>
                  <Link to="/kyc-policy">AML/KYC Policy</Link>
                </li>
                <li>
                  <Link to="/complaints">Complaints</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-of-service">Terms of Service</Link>
                </li>
                <li>
                  <Link to="/cookies">Cookies</Link>
                </li>
                <li>
                  <a href="mailto:contact@peergame.com">Contact Us</a>
                </li>
              </ul>
            </div>
            <div className={cx('footer-right-block')}>
              <h6>Join us</h6>
              <div className={cx('logo-box')}>
                <a
                  href="https://discord.gg/cH4jbGS"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Peergame's Discord"
                >
                  <img src={ImgIconDiscord} alt="" />
                </a>
                <a
                  href="https://twitter.com/PeergameEng"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Peergame's Twitter"
                >
                  <img src={ImgIconTwitter} alt="" />
                </a>
                <a href="https://t.me/peergame" target="_blank" rel="noopener noreferrer" title="Peergame's Telegram">
                  <img src={ImgIconTelegram} alt="" />
                </a>
                <a
                  href="https://bitcointalk.org/index.php?topic=5257254"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Perrgame's Bitcointalk"
                >
                  <img src={ImgIconBitcointalk} alt="" />
                </a>
              </div>
              <div className={cx('footer-right-block-card')}>
                <img src={ImgIconAdult} alt="" />
                <div className="">
                  <p className="xsmall">
                    Gambling can be addictive.
                    <br />
                    Play responsibly.
                  </p>
                </div>
              </div>
              <div className={cx('footer-right-block-bottom')}>
                <a
                  href="https://www.begambleaware.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Be Gambling Aware"
                >
                  <img src={ImgLogoBeGambleAware} alt="" />
                </a>
                <a
                  href="https://www.gamblersanonymous.org.uk"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Gamblers Anonymous"
                >
                  <img src={ImgLogoGA} alt="" />
                </a>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
